<template>
  <div>
    <vx-card title="Description">
        <p class="mb-5">Create a Question</p>

        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <v-select :options="data.subject" v-model="group.subject" label="label" placeholder="Select Class Subject"  />
          </div>
          <div class="vx-col sm:w-1/4 w-full mb-2">
            <v-select :options="data.category" v-model="group.category" placeholder="Select Category"  />
          </div>
          <!-- <div class="vx-col sm:w-1/4 w-full mb-2">
            <v-select :options="data.duration" v-model="group.duration" placeholder="Select Task Duration"  />
          </div> -->
          <!-- <div class="vx-col sm:w-1/4 w-full mb-2">
            <vs-input class="w-full" v-model="group.title" placeholder="Task Title" />
          </div> -->
        </div>

    </vx-card>

    <!-- <br>
    <br>
    <vx-card title="Video">
        <p class="mb-5">Upload video. Videos should be of reduced sizes.</p>
        <vs-upload action="https://swfgdev.s3.eu-west-2.amazonaws.com/folder/test.jpg?Content-Type=jpeg&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAWKQJBFNTSJ3BDJPB%2F20200422%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20200422T124301Z&X-Amz-Expires=7200&X-Amz-Signature=22c5d86e4906ff591ba91e203b9862de28d283920be0aa31f45eec43b6c5d652&X-Amz-SignedHeaders=host" @on-success="successUpload" />
    </vx-card> -->

    <br>
    <br>

    <vx-card title="Question">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <p>Ente Question</p>
          <br>
          <template>
            <div>
              <vs-textarea v-model="data.question" rows="4" />
            </div>
          </template>
        </div>
        <div class="vx-col sm:w-1/4 w-full mb-2">
          <p>Option Type</p>
          
          <br>
          <ul class="centerx">
            <li><vs-radio v-model="data.optionType" vs-value="multipleopt">Multiple Option</vs-radio></li>
            <li><vs-radio v-model="data.optionType" vs-value="multiplesel">Multiple Select</vs-radio></li>
            <li><vs-radio v-model="data.optionType" vs-value="fillspace">Fill a Space</vs-radio></li>
            <li><vs-radio v-model="data.optionType" vs-value="write">Write a Paragraph</vs-radio></li>
          </ul>
        </div>
        <div class="vx-col sm:w-1/4 w-full mb-2">
          <p>Answer / Options</p>

          <br>
          <div v-if="data.optionType === 'multipleopt'">
            <ol class="optionlist" start="1" type="1">
              <li>
                <vs-row vs-w="12">
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                    <vs-radio v-model="data.control.radio.final.a1" vs-value="1"></vs-radio>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                    <input size="small" class="oinputx" placeholder="" v-model="data.control.radio.options.v1"/>
                  </vs-col>
                </vs-row>
              </li>
              <li>
                <vs-row vs-w="12">
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                    <vs-radio v-model="data.control.radio.final.a1" vs-value="2"></vs-radio>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                    <input size="small" class="oinputx" placeholder="" v-model="data.control.radio.options.v2"/>
                  </vs-col>
                </vs-row>
              </li>
              <li>
                <vs-row vs-w="12">
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                    <vs-radio v-model="data.control.radio.final.a1" vs-value="3"></vs-radio>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                    <input size="small" class="oinputx" placeholder="" v-model="data.control.radio.options.v3"/>
                  </vs-col>
                </vs-row>
              </li>
              <li>
                <vs-row vs-w="12">
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                    <vs-radio v-model="data.control.radio.final.a1" vs-value="4"></vs-radio>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                    <input size="small" class="oinputx" placeholder="" v-model="data.control.radio.options.v4"/>
                  </vs-col>
                </vs-row>
              </li>
              <li>
                <vs-row vs-w="12">
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                    <vs-radio v-model="data.control.radio.final.a1" vs-value="5"></vs-radio>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                    <input size="small" class="oinputx" placeholder="" v-model="data.control.radio.options.v5"/>
                  </vs-col>
                </vs-row>
              </li>
            </ol>
          </div>
          <div v-else-if="data.optionType === 'multiplesel'">
            <ol class="optionlist" start="1" type="1">
              <li>
                <vs-row vs-w="12">
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                    <vs-checkbox v-model="data.control.check.final.a1" vs-value="1"></vs-checkbox>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                    <input size="small" class="oinputx" placeholder="" v-model="data.control.check.options.v1"/>
                  </vs-col>
                </vs-row>
              </li>
              <li>
                <vs-row vs-w="12">
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                    <vs-checkbox v-model="data.control.check.final.a2" vs-value="2"></vs-checkbox>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                    <input size="small" class="oinputx" placeholder="" v-model="data.control.check.options.v2"/>
                  </vs-col>
                </vs-row>
              </li>
              <li>
                <vs-row vs-w="12">
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                    <vs-checkbox v-model="data.control.check.final.a3" vs-value="3"></vs-checkbox>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                    <input size="small" class="oinputx" placeholder="" v-model="data.control.check.options.v3"/>
                  </vs-col>
                </vs-row>
              </li>
              <li>
                <vs-row vs-w="12">
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                    <vs-checkbox v-model="data.control.check.final.a4" vs-value="4"></vs-checkbox>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                    <input size="small" class="oinputx" placeholder="" v-model="data.control.check.options.v4"/>
                  </vs-col>
                </vs-row>
              </li>
              <li>
                <vs-row vs-w="12">
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                    <vs-checkbox v-model="data.control.check.final.a5" vs-value="5"></vs-checkbox>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                    <input size="small" class="oinputx" placeholder="" v-model="data.control.check.options.v5"/>
                  </vs-col>
                </vs-row>
              </li>
            </ol>
          </div>
          <div v-else-if="data.optionType === 'fillspace'">
            <input size="small" class="oinputx" placeholder="" v-model="data.control.fill.final.a1"/>
          </div>
          <div v-else-if="data.optionType === 'write'">
            No options or answer.
          </div>
          <div v-else>
            <span class="text-mute">Select an option type</span>
          </div>

        </div>

        <div class="vx-col w-full">
          <vs-button class="mr-3 mb-2" @click="addQuestion">Save</vs-button>
        </div>
      </div>
    </vx-card>


  </div>
</template>

<script>
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import vSelect from 'vue-select'

import { quillEditor } from 'vue-quill-editor'
import Prism from 'vue-prism-component'

export default {
  data () {
    return {
      group: {
        subject: null,
        category: null,
        title:null,
        content: null
      },
      data: {
        question: '',
        optionType: null,
        subject: [],
        category: [],
        duration: [
          { duration: 15, label: '15 minutes' },
          { duration: 30, label: '30 minutes' },
          { duration: 45, label: '45 minutes' },
          { duration: 60, label: '1 hour' },
          { duration: 90, label: '1 hours, 30 mins' },
          { duration: 120, label: '2 hours' }
        ],
        initControl: null,
        control: {
          check: {
            final: {
              a1: null,
              a2: null,
              a3: null,
              a4: null,
              a5: null
            },
            options: {
              v1: null,
              v2: null,
              v3: null,
              v4: null,
              v5: null
            }
          },
          radio: {
            final: {
              a1: null
            },
            options: {
              v1: null,
              v2: null,
              v3: null,
              v4: null,
              v5: null
            }
          },
          fill: {
            final: {
              a1: null
            }
          }
        }
      }
    }
  },
  components: {
    quillEditor,
    Prism,
    vSelect
  },
  created () {
    this.data.initControl = JSON.parse(JSON.stringify(this.data.control))

    this.$http.get('/lms/st/academics/subject/assigned').then((response) => {
      if (response && response.data && response.data.data) {
        const tracker = { subj: {}, class: {} }

        response.data.data.forEach((v) => {
          const subjKey = parseInt(`${v.subj_id}${v.rank.toString().slice(0, 2)}`)

          if (!tracker.subj[subjKey]) {
            this.data.subject.push({ subj_id: v.subj_id, rank: v.rank, class_id: v.class_id, subj: v.subj_short, class: v.class_short, label: `${v.class_short.slice(0, 3)} - ${v.name}` })
          }
          
          tracker.subj[subjKey] = 1
        })
      }
    }).catch((error) => { 
      console.log(error)
    })

    this.$http.get('/lms/st/task/category').then((response) => {
      if (response && response.data && response.data.data) {
        response.data.data.forEach((v) => {
          this.data.category.push({ id: v.id, label: v.name })
        })
      }
    }).catch((error) => { 
      console.log(error)
    })
  },
  methods: {
    addQuestion () {
      if (!(this.group.subject)) {
        return this.$vs.notify({ color: 'danger', title: 'No Class or Subject', text: 'Select a class subject' })
      }

      if (!this.group.category) {
        return this.$vs.notify({ color: 'danger', title: 'No Categoy', text: 'Select a category' })
      }

      if (!this.data.question) {
        return this.$vs.notify({ color: 'danger', title: 'Incomplete Question', text: 'Enter a question' })
      }

      if (!this.data.optionType) {
        return this.$vs.notify({ color: 'danger', title: 'No Option Type', text: 'Select an option type' })
      }

      let noOptions = false
      const typeOptions = {}
      const typeAnswer = []

      switch (this.data.optionType) {
      case 'multipleopt':
        if (!this.data.control.radio.options.v1) noOptions = true
        for (const o in this.data.control.radio.options) {
          if (this.data.control.radio.options[o]) {
            typeOptions[o] = this.data.control.radio.options[o]
          }
        }
        for (const o in this.data.control.radio.final) {
          if (this.data.control.radio.final[o]) {
            typeAnswer.push(this.data.control.radio.final[o])
          }
        }
        break
      case 'multiplesel':
        if (!this.data.control.check.options.v1) noOptions = true
        for (const o in this.data.control.check.options) {
          if (this.data.control.check.options[o]) {
            typeOptions[o] = this.data.control.check.options[o]
          }
        }
        for (const o in this.data.control.check.final) {
          console.log(o, this.data.control.check.final[o])
          if (this.data.control.check.final[o]) {
            typeAnswer.push(this.data.control.check.final[o])
          }
        }
        break
      case 'fillspace':
        console.log('filling space mode', this.data.control.fill.final.a1)
        typeAnswer.push(this.data.control.fill.final.a1)
      }

      if (noOptions) {
        this.$vs.notify({ color: 'danger', title: 'No Answer Options', text: 'Add 1 or more answer options' })
      }

      console.log(this.group.subject)

      const questionObject = {
        rank: this.group.subject.rank,
        subj_id: this.group.subject.subj_id,
        cat: this.group.category.id,
        q: this.data.question,
        t: this.data.optionType,
        to: typeOptions,
        f: typeAnswer
      }

      this.$vs.loading()
      this.$http.post('/lms/st/task/question', questionObject).then((response) => {
        this.$vs.loading.close()
        if (response && response.data && response.data.data) {
          this.$vs.notify({ color: 'success', title: 'Upload Success', text: 'Question uploaded' })
          this.data.question = null
          this.data.optionType = null
          this.data.control = JSON.parse(JSON.stringify(this.data.initControl))
        } else {
          this.$vs.notify({ color: 'warning', title: 'Seems there is a Problem', text: 'Check question bank' })
        }
      }).catch((error) => { 
        this.$vs.loading.close()
        console.log(error)
        this.$vs.notify({ color: 'danger', title: 'Check Internet', text: 'Unable to connect' })
      })
    },

  }
}
</script>


<style scoped>
ol.optionlist {
  list-style: outside;
  list-style-type: decimal;
}

ol.optionlist li {
  margin: 10px;
}

input.oinputx {
  width: 100%;
  padding-left: 5px;
  font-size: 15px;
  color: #626262;
  background: transparent;
  border: none;
  border-bottom: 1px solid #ddd;
}
</style>